import { z } from 'zod';

export const locationAddressZ = z.object({
  line1: z.string().min(1, 'Address line 1 is required'),
  line2: z.string().optional(),
  city: z.string().min(1, 'City is required'),
  state: z.string().optional(),
  postalCode: z.string().optional(),
  country: z
    .string()
    .length(2, 'Country must be a 2-letter ISO code')
    .regex(/^[A-Z]{2}$/, 'Country must be a 2-letter ISO code'),
});

export const locationGeoZ = z.object({
  lat: z
    .number()
    .min(-90, 'Latitude must be between -90 and 90')
    .max(90, 'Latitude must be between -90 and 90'),
  lng: z
    .number()
    .min(-180, 'Longitude must be between -180 and 180')
    .max(180, 'Longitude must be between -180 and 180'),
});

export const locationZ = z.object({
  _id: z.string().optional(),
  organizationId: z.string().optional(),
  name: z
    .string()
    .min(1, 'Location name is required')
    .max(100, 'Location name must be less than 100 characters'),
  code: z.string().optional(),
  isActive: z.boolean().default(true),
  notes: z.string().optional(),
  address: locationAddressZ,
  geo: locationGeoZ,
  createdAt: z.date().optional(),
  updatedAt: z.date().optional(),
});

export const locationCreateZ = locationZ.omit({ _id: true, createdAt: true, updatedAt: true });
export const locationUpdateZ = locationZ
  .partial()
  .omit({ _id: true, createdAt: true, updatedAt: true, organizationId: true });

export type Location = z.infer<typeof locationZ>;
export type LocationCreate = z.infer<typeof locationCreateZ>;
export type LocationUpdate = z.infer<typeof locationUpdateZ>;
export type LocationAddress = z.infer<typeof locationAddressZ>;
export type LocationGeo = z.infer<typeof locationGeoZ>;
